module.exports = __webpack_public_path__ + "img/logo.326d7ece.png";